<script>
	import {
		Button,
		Modal,
		ModalBody,
		ModalFooter,
		ModalHeader,
	} from "@sveltestrap/sveltestrap";

	import { modalOpen, userId, fetchGroupModal } from "../../store/store";
	import { get } from "svelte/store";
	import { onMount, onDestroy } from "svelte";
	import client from "../../services/client";
	import Swal from "sweetalert2";
	import CustomSearch from "../CustomSearch/CustomSearch.svelte";
	let data;
	let open;
	let groupId;
	modalOpen.subscribe((value) => {
		open = value;
	});
	let dataGroup = [];

	const fetchGroup = async (e) => {
		try {
			const res = await client("/v0/Group/GetWithFilters", {
				method: "POST",
				version: "Tasking",
				data: { name: e },
			});
			data = res.data.data.groups;

			dataGroup = data.map((value) => {
				return {
					value: value.groupId,
					label: value.name,
				};
			});
			return dataGroup;
		} catch (err) {
			console.log(err.response);
		}
	};
	const toggle = () => modalOpen.set(false);

	onMount(() => {
		if (get(fetchGroupModal)) {
			fetchGroup();
		}
	});

	onDestroy(() => {
		modalOpen.set(false);
		fetchGroupModal.set(false);
	});

	const handleSubmit = () => {
		toggle();
		Swal.fire({
			title: `Do you want to assign the user to the group ?`,
			showDenyButton: true,
			confirmButtonText: "<b>OK</b>",
			denyButtonText: `Cancel`,
			confirmButtonColor: "#19F9B9",
			customClass: {
				confirmButton: "primary", //insert class here
			},
		}).then((result) => {
			/* Read more about isConfirmed, isDenied below */
			if (result.isConfirmed) {
				client("/v0/Group/AssignGrouping", {
					method: "POST",
					version: "Tasking",
					data: {
						user: get(userId),
						group: groupId.value,
					},
				})
					.then((res) => {
						if (res.data.error_code === 400) {
							Swal.fire({
								icon: "error",
								title: "Oops...",
								html: `${res.data.error_msg}`,
								confirmButtonColor: "#DC3741",
							});
						} else if (res.data.error_code === 0) {
							Swal.fire({
								icon: "success",
								title: "Success!",
								text: ` User has been assigned to the group`,
								confirmButtonColor: "#19F9B9",
								customClass: {
									confirmButton: "primary", //insert class here
								},
							});
						}
					})
					.catch((err) => {
						console.log(err.response.data);
						Swal.fire({
							icon: "error",
							title: "Oops...",
							text: "Something went wrong!",
						});
					});
			} else if (result.isDenied) {
				Swal.fire({
					text: "Changes are not saved",
					icon: "info",
					confirmButtonColor: "#19F9B9",
					customClass: {
						confirmButton: "primary", //insert class here
					},
				});
			}
		});
	};
</script>

<div>
	<Modal isOpen={open} backdrop centered>
		<ModalHeader>Select group to assign!</ModalHeader>

		<ModalBody>
			<CustomSearch
				loadOptions={fetchGroup}
				placeholder="Select group"
				items={dataGroup}
				bind:value={groupId}
				label="name"
			/>
		</ModalBody>
		<ModalFooter>
			<Button class="primary" on:click={() => handleSubmit()}
				>Assign</Button
			>
			<Button color="danger" on:click={toggle}>Cancel</Button>
		</ModalFooter>
	</Modal>
</div>

<style>
	:global(.svelte-autocomplete-select-input) {
		width: 100%;
	}
</style>
